import React, { memo, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import siteLogo from "../assets/images/logo.png";

import HeaderUserDropDown from "../components/HeaderUserDropDown";
import HeaderNavigation from "../components/HeaderNavigation";
import SideMenu from "../components/SideMenu";
import HeaderSearch from "../components/HeaderSearch";
import MobileBanner from "../components/MobileBanner"
import { getHomePageCategories ,getSettings,getHeaderMenu,getMenuBanner,getSeoAnalytics} from "../services/HomePageService";
import { getUserSession } from "../auth";
import HeaderFavCountIcon from "../components/HeaderFavCountIcon";
import { Helmet } from "react-helmet";
import MobileFooter from "./MobileFooter";
const SiteHeader = () => {
  useEffect(() => {
    getCats();
    getMenu();
    getBanner();
    getSettingsData();
 //   getSeoData();
  }, []);

  const [categories, setCategories] = useState({ loader: true, data: [] });
  const [menu, setMenu] = useState({ loader: true, data: [] });
  const [menubanner, setMenubanner] = useState({ loader: true, data: [] });
  const [settings, setSettings] = useState({ loader: true, data: [] });
 // const [seoData, setSeoData] = useState({ loader: true, data: [] });
 const [isOpen, setIsopen] = useState(false);

 const [isMobileActive, setIsMobileActive] = useState(false);
 useEffect(() => {
  const mediaQuery = window.matchMedia("(max-width: 575.98px)");

  const handleResize = () => {
    setIsMobileActive(mediaQuery.matches);
  };

  handleResize(); // برای بررسی اولیه

  mediaQuery.addEventListener("change", handleResize);
  
  return () => {
    mediaQuery.removeEventListener("change", handleResize);
  };
}, []);


  const getCats = async () => {
    const catData = await getHomePageCategories();
    if (catData) {
      setCategories({
        loader: false,
        data: catData,
      });
     
    }
  };
  // const getSeoData = async () => {
  //   const setSeo = await getSeoAnalytics();
  //   if (setSeo) {
  //     setSeoData({

  //       loader: false,
  //       data: setSeo,
  //     });
  //   }
  // };
  const getMenu = async () => {
    const catData = await getHeaderMenu();
    if (catData) {
      setMenu({
        loader: false,
        data: catData,
      });
    }
  };
  const getBanner = async () => {
    const catData = await getMenuBanner();
    if (catData) {
      setMenubanner({
        loader: false,
        data: catData,
      });
    }
  };
  const getSettingsData = async () => {
    const settData = await getSettings();
    if (settData) {
      setSettings({
        loader: false,
        data: settData,
      });
    }
  };
  // const AddHelmet = ({ data }) => {

  //   return (
  //     <>
  //       {/* <Helmet> */}
  //       {data &&
  //         data.map(({ analytics_code ,code_position}) => (
  //           <>
  
  //             {code_position == 2 ? (
  //               // <Helmet> 
  //                 // {analytics_code}
  //               // </Helmet>
  //               <div dangerouslySetInnerHTML={{ __html: analytics_code }} />
  //             ) : ("")
  //             }
  
  //           </>
  //         ))}
  //       {/* </Helmet> */}
  //     </>
  
  //   );
  // };
  const userSession = getUserSession();
  // console.log("current Session");
  // console.log(userSession);
  return (
    <>
        {/* <AddHelmet data={seoData.data} /> */}
      <header className='header clearfix'>
        <div className='top-header-group'>
          <div className='top-header'>
            <div className='res_main_logo'>
              {/* <a href='/' title="Home">
                <img src={siteLogo} alt='logo' />
              </a> */}
              <Link to="/"><img src={siteLogo} alt='logo' /></Link>
            </div>
            <div className='main_logo' id='logo'>
              {/* <a href='/' title="Home">
                <img src={siteLogo} alt='logo' />
              </a> */}
              <Link to="/"><img src={siteLogo} alt='logo' /></Link>
              {/* <a href='/' title="Home">
                <img className='logo-inverse' src={siteLogo} alt='logo' />
              </a> */}
              <Link to="/"><img src={siteLogo} className='logo-inverse' alt='logo' /></Link>
            </div>
          
            <HeaderSearch className='d-none d-sm-block search120' />

            <div className='header_right'>
              <ul>
                <li>
                  <a href={'tel:'+settings.data.phone_number} className='offer-link'>
                    <i className='uil uil-phone-alt'></i>{settings.data.phone_number}
                  </a>
                </li>

                <HeaderFavCountIcon />
                <HeaderUserDropDown
                  isLoggedIn={
                    userSession && userSession.authToken ? true : false
                  }
                  userName={(userSession && userSession.full_name) || ""}
                  isGuest={
                    (userSession && userSession.userType) === 2 ? true : false
                  }
                />
              </ul>
            </div>
          </div>
          
 
          <MobileBanner className='top-header' />
          <HeaderSearch className='d-inline-block d-sm-none search-sm w-100' />
        </div>
        <div className='sub-header-group'>
          <div className='sub-header '>
            <SideMenu data={categories} getOpen={isOpen} setIsopen= {setIsopen} />
            <HeaderNavigation data={menu} menubanner={menubanner}/>   
             
          </div>
        </div>  
       
        {isMobileActive && <MobileFooter data={categories} getOpen={isOpen} setOpen= {setIsopen} />}
      </header>
    </>
  );
};

export default memo(SiteHeader);
